export const locale = {
 lang: 'en',
 data: {
     INFORMATIONS:'Informations',
     CONFIRMATION_MESSAGE_PUBLIC_TO_PRIVATE: 'Your workshop is now private. You can add your participants email to grant them access.',
     CONFIRMATION_MESSAGE_PRIVATE_TO_PUBLIC: 'You workshop is now public. You can share the link with your participants. ',
     BUTTON_MESSAGE: 'Confirm'
     }
};
